module.exports = __webpack_public_path__ + "static/media/environment.5309c1bb.svg";